/* ============================================================================
   NHG Mega Menu — Behavior
   ============================================================================
   Vanilla JS, no dependencies. Defer-loaded.

   Features:
     - Hover open with grace period; hover anywhere on trigger OR panel keeps open
     - Click-to-toggle: clicking trigger opens/closes definitively
     - Keyboard: Tab navigation, Enter/Space to open, Escape to close
     - Click outside closes all panels
     - Department rail: hover or click swaps the right pane
     - "+ N more" toggles overflow aisles per column
     - Mobile drawer: auto-binds to common Empire mobile-toggle selectors
     - Sticky-header re-binding: document-level capture catches both static
       and Empire's sticky-header-swapped hamburger
   ============================================================================ */

(function () {
  'use strict';

  var root = document.querySelector('[data-nhg-mega-root]');
  if (!root) return;

  var GRACE_MS = 200;
  var DESKTOP_BREAKPOINT = 980;

  var items = Array.prototype.slice.call(root.querySelectorAll('[data-nhg-mega-trigger]'));
  var closeTimers = {};
  var hoverStates = {};

  function isDesktop() {
    return window.innerWidth > DESKTOP_BREAKPOINT;
  }

  function getKey(item) {
    return item.getAttribute('data-nhg-mega-trigger');
  }

  function openItem(item) {
    if (!item || item.classList.contains('is-open')) return;
    closeAll(item);
    item.classList.add('is-open');
    var trigger = item.querySelector('.nhg-mega__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var panel = item.querySelector('.nhg-mega__panel');
    if (panel) panel.setAttribute('aria-hidden', 'false');
  }

  function closeItem(item) {
    if (!item) return;
    item.classList.remove('is-open');
    var trigger = item.querySelector('.nhg-mega__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    var panel = item.querySelector('.nhg-mega__panel');
    if (panel) panel.setAttribute('aria-hidden', 'true');
  }

  function closeAll(except) {
    items.forEach(function (it) { if (it !== except) closeItem(it); });
  }

  function cancelClose(key) {
    if (closeTimers[key]) { clearTimeout(closeTimers[key]); closeTimers[key] = null; }
  }

  function scheduleClose(item) {
    var key = getKey(item);
    cancelClose(key);
    closeTimers[key] = setTimeout(function () {
      if (!hoverStates[key]) closeItem(item);
    }, GRACE_MS);
  }

  items.forEach(function (item) {
    var trigger = item.querySelector('.nhg-mega__trigger');
    var panel = item.querySelector('.nhg-mega__panel');
    if (!trigger) return;

    var key = getKey(item);
    hoverStates[key] = false;

    function onEnter() {
      if (!isDesktop()) return;
      hoverStates[key] = true;
      cancelClose(key);
      openItem(item);
    }
    function onLeave() {
      if (!isDesktop()) return;
      hoverStates[key] = false;
      scheduleClose(item);
    }

    trigger.addEventListener('mouseenter', onEnter);
    trigger.addEventListener('mouseleave', onLeave);

    if (panel) {
      panel.addEventListener('mouseenter', onEnter);
      panel.addEventListener('mouseleave', onLeave);
    }

    trigger.addEventListener('click', function (e) {
      if (trigger.tagName === 'A') return;
      e.preventDefault();
      e.stopPropagation();
      if (item.classList.contains('is-open')) {
        hoverStates[key] = false;
        closeItem(item);
      } else {
        hoverStates[key] = true;
        openItem(item);
      }
    });

    trigger.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && trigger.tagName === 'BUTTON') {
        e.preventDefault();
        openItem(item);
        hoverStates[key] = true;
        var firstLink = panel ? panel.querySelector('a') : null;
        if (firstLink) firstLink.focus();
      } else if (e.key === 'Escape') {
        closeItem(item);
        hoverStates[key] = false;
        trigger.focus();
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!root.contains(e.target)) {
      items.forEach(function (it) { hoverStates[getKey(it)] = false; });
      closeAll();
    }
  });

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      items.forEach(function (it) { hoverStates[getKey(it)] = false; });
      closeAll();
    }
  });

  var lastIsDesktop = isDesktop();
  window.addEventListener('resize', function () {
    if (isDesktop() !== lastIsDesktop) {
      items.forEach(function (it) { hoverStates[getKey(it)] = false; });
      closeAll();
      lastIsDesktop = isDesktop();
    }
  });

  // ----------------------------------------------------------------------
  // Department rail: hover/focus swaps the right pane
  // ----------------------------------------------------------------------
  var deptPanel = root.querySelector('.nhg-mega__panel--departments');
  if (deptPanel) {
    var deptTabs = Array.prototype.slice.call(deptPanel.querySelectorAll('[data-nhg-dept-tab]'));
    var deptPanes = Array.prototype.slice.call(deptPanel.querySelectorAll('[data-nhg-dept-pane]'));

    function showDept(slug) {
      deptTabs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-nhg-dept-tab') === slug);
      });
      deptPanes.forEach(function (p) {
        var isMatch = p.getAttribute('data-nhg-dept-pane') === slug;
        p.classList.toggle('is-active', isMatch);
        p.setAttribute('aria-hidden', isMatch ? 'false' : 'true');
      });
    }

    deptTabs.forEach(function (tab) {
      var slug = tab.getAttribute('data-nhg-dept-tab');
      var link = tab.querySelector('.nhg-mega__dept-rail-link');

      tab.addEventListener('mouseenter', function () {
        if (isDesktop()) showDept(slug);
      });

      if (link) {
        link.addEventListener('focus', function () { showDept(slug); });
      }
    });
  }

  // ----------------------------------------------------------------------
  // "+ N more" toggles per column
  // ----------------------------------------------------------------------
  Array.prototype.slice.call(root.querySelectorAll('[data-nhg-mega-more]')).forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var col = btn.closest('.nhg-mega__column');
      if (!col) return;
      var nowExpanded = col.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', nowExpanded ? 'true' : 'false');
    });
  });

  // ----------------------------------------------------------------------
  // Mobile drawer (open/close)
  // ----------------------------------------------------------------------
  var mobile = document.querySelector('[data-nhg-mega-mobile]');
  if (!mobile) return;

  // Measure Empire's header height so the drawer doesn't tuck under it
  // Drawer covers the full viewport with max z-index, so no header offset
  // detection needed. The drawer sits above everything including Empire's
  // sticky header — its own header (Shop + close) is always visible at top.

  // Inject backdrop element right before the drawer (clicking it closes drawer)
  var backdrop = document.createElement('div');
  backdrop.className = 'nhg-mega-mobile-backdrop';
  backdrop.setAttribute('aria-hidden', 'true');
  mobile.parentNode.insertBefore(backdrop, mobile);
  backdrop.addEventListener('click', function () {
    window.NHGMegaMobile.close();
  });

  window.NHGMegaMobile = {
    open: function () {
      mobile.classList.add('is-open');
      backdrop.classList.add('is-open');
      mobile.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },
    close: function () {
      mobile.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      mobile.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    toggle: function () {
      mobile.classList.contains('is-open') ? this.close() : this.open();
    }
  };

  var closeBtn = mobile.querySelector('[data-nhg-mobile-close]');
  if (closeBtn) closeBtn.addEventListener('click', function () { window.NHGMegaMobile.close(); });

  // Click outside the drawer closes it
  document.addEventListener('click', function (e) {
    if (!mobile.classList.contains('is-open')) return;
    // Ignore clicks inside the drawer itself
    if (mobile.contains(e.target)) return;
    // Ignore clicks on the hamburger toggle (handled separately)
    var t = e.target;
    while (t && t !== document.body) {
      if (matchesAny(t, EMPIRE_MOBILE_SELECTORS)) return;
      t = t.parentElement;
    }
    window.NHGMegaMobile.close();
  });

  // Escape key closes
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobile.classList.contains('is-open')) {
      window.NHGMegaMobile.close();
    }
  });

  // --- Empire mobile hamburger auto-bind --------------------------------
  // Empire 2.0 uses several selectors for the mobile hamburger across
  // static vs. sticky header DOM. We listen at the document level in
  // CAPTURE phase, so we intercept clicks before Empire's own handlers fire.
  // Catches the original AND the sticky-header replacement.
  var EMPIRE_MOBILE_SELECTORS = [
    '[data-nhg-mobile-toggle]',
    // Empire 2.0 — confirmed selectors
    '.site-header-menu-toggle',
    'button[data-menu-toggle]',
    // Other common Empire variants
    '.header__nav-mobile-toggle',
    '.header__mobile-nav-toggle',
    '.header__mobile-toggle',
    '.mobile-nav__toggle',
    '.js-mobile-nav-toggle',
    '.header__icon--menu',
    '.header__icon-menu',
    '.header__menu-toggle',
    'button.mobile-nav-toggle',
    'button[aria-label*="menu" i]',
    'button[aria-label*="navigation" i]'
  ];

  function matchesAny(el, selectors) {
    if (!el || !el.matches) return false;
    for (var i = 0; i < selectors.length; i++) {
      try { if (el.matches(selectors[i])) return true; } catch (e) {}
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    while (target && target !== document.body) {
      if (matchesAny(target, EMPIRE_MOBILE_SELECTORS)) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        window.NHGMegaMobile.toggle();
        return;
      }
      target = target.parentElement;
    }
  }, true);

})();
